import React, { Component } from 'react';
import InvitedAdd from "./InvitedAdd";
import InvitedEdit from "./InvitedEdit";
import { getURL } from '../../backend/Backend';
import { sendJson, deleteItem } from '../../backend/Backend';
import { ListGroup, Pagination, Button, Col, OverlayTrigger, Tooltip, Row, Form } from 'react-bootstrap';
import '../App.css';
import { translate } from "react-i18next";
import i18n from "i18next";

function emptyInvited() {
    return {
        comment: '',
        modificationUser: '',
        eventId: '',
        creationDate: '',
        userId: ''
    };
}

class InvitedEditList extends Component {
    constructor(props) {
        super(props);
        this.onDelete = this.onDelete.bind(this);
        this.onItemInputChange = this.onItemInputChange.bind(this);
        this.onItemUpdate = this.onItemUpdate.bind(this);
        this.pageChanged = this.pageChanged.bind(this);
        this.onReload = this.onReload.bind(this);
        this.onEdit = this.onEdit.bind(this);
        this.onInvitedEdit = this.onInvitedEdit.bind(this);
        this.onInvitedDelete = this.onInvitedDelete.bind(this);
        this.onInvitedRevert = this.onInvitedRevert.bind(this);
        this.onAdd = this.onAdd.bind(this);
        this.state = {
            selected: emptyInvited(),
            inviteds: [],
            activePage: 1,
            totalPages: 0,
            invitedUser: this.props.invitedUser,
            edit: false
        };
    }


    onEdit(invited) {
        let oldState = this.state;
        this.setState({
            ...oldState,
            selected: invited,
            edit: !oldState.edit
        });
    }

    onAdd(user) {
        let uLang = i18n.language;
       let newUser = {name:user.username, email:user.email, eventId: user.eventId, invitationStatus:  user.invitationStatus, lang: uLang};
       sendJson('post', 'eventInvitedUsers/', newUser).then(
            received => {
                this.loadInviteds(this.state.activePage);
            });
    }

 

    onDelete(id) {
        fetch(getURL('userComments/delete/' + id + '/test'))
            .then((response) => {
                this.props.removeInvited(id);
            })
            .catch((error) => {
                console.error(error);
            });

    }


    onInvitedEdit(invited) {
        sendJson('put', 'eventInvitedUsers', invited).then(
            received => {
                this.loadInviteds(this.state.activePage);
            });
    }

    onInvitedDelete(id) {
        deleteItem('eventInvitedUsers', id).then(
            received => {
                this.loadInviteds(this.state.activePage);
            });

    }

    onInvitedRevert() {
        this.loadInviteds(this.state.activePage);
    }

    /*onActivate(invited, invitationStatus){
         
    }*/


    async componentDidMount() {
        this.loadInviteds(1);
    }

    async onReload() {
        const response = await fetch(getURL(`userComments/${this.props.id}/0/`));
        const json = await response.json();
        let oldState = this.state;
        this.setState({
            ...oldState,
            inviteds: json.content,
            activePage: 1
        });
    }

    onItemInputChange(event) {
        const { name: fieldName, value: fieldValue } = event.target;
        const newInvited = {
            ...this.state.selected,
            [fieldName]: fieldValue
        };

        this.setState({
            selected: newInvited
        });
    }

    onItemUpdate(invited) {
        sendJson('post', 'userComments/save', invited).then(
            received => {
                this.props.updateInvited(received);
            });
    }

    handlePageChange(pageNumber) {
        let oldState = this.state;
        this.setState({
            ...oldState,
            activePage: pageNumber
        });
    }

    async pageChanged(e) {
        this.loadInviteds(e.target.text);
    }

    async loadInviteds(page) {
        if (!page) {
            return;
        }
        if ("<" === page) {
            page = --this.state.activePage;
        }
        if (">" === page) {
            page = ++this.state.activePage;
        }
        const response = await fetch(getURL(`eventInvitedUsers/loadAllInviteds/${this.props.id}/${page - 1}`));
        const json = await response.json();
        let oldState = this.state;
        this.setState({
            ...oldState,
            inviteds: json.content,
            totalPages: json.totalPages,
            activePage: page,
            selected: emptyInvited(),
            edit: false
        });
    }

    /*
    {(!this.state.edit) ?
                  <InvitedAdd onAdd={this.onAdd}  eventId={this.props.eventId} />
                  :
                  ""
            }
    */
    render() {
        const { t } = this.props;
        return (<div>
            
            <Row className="pt-1 pl-1 ">
                                <Col>
                    <Form.Label>{t("allTeilnehmern")}</Form.Label>
                                </Col>
                            </Row>
                            
            {(this.state.inviteds) ?
                <ListGroup>
                    {this.state.inviteds.map((invited, i) => {
                        if (this.state.edit && this.state.selected && this.state.selected.id === invited.id) {
                            return <InvitedEdit selected={invited} onInvitedEdit={this.onInvitedEdit} onInvitedDelete={this.onInvitedDelete} onInvitedRevert={this.onInvitedRevert} key={i} />
                        } else {
                            return <div key={i}>
                                <Row className="pt-1 pl-2">
                                    <Col >
                                        {invited.name}
                                    </Col>
                                    <Col >
                                        <span className="commentAuthor">{invited.email}</span>
                                    </Col>
                                   
                                    <Col >
                                        <OverlayTrigger key="top" placement="top" overlay={
                                                        <Tooltip id={`tooltip-top`}> {t("bearbeiten")}</Tooltip>}>
                                                    <Button variant="outline-primary" onClick={() => this.onEdit(invited)}  ><span className="fa fa-edit"></span></Button>
                                            </OverlayTrigger>
                                    </Col>
                                </Row>
                        
                                <Row>
                                    <Col > <hr></hr></Col>
                                </Row>

                            </div>
                        }
                    })}
                </ListGroup>
                :
                ""
            }


            <Pagination onClick={this.pageChanged}  className="pt-1 pl-2 pb-2">
                {this.state.activePage > 1 ?
                    <Pagination.Item>{'<'}</Pagination.Item>
                    : ""
                }

                {[...Array(this.state.totalPages).keys()].map(i => {
                    return <Pagination.Item active={(i + 1) === this.state.activePage} key={i} >{i + 1}</Pagination.Item>
                })
                }
                {this.state.activePage < this.state.totalPages ?
                    <Pagination.Item>{'>'}</Pagination.Item>
                    : ""
                }

            </Pagination>

            
        </div>);
    }
}

export default translate("translations")(InvitedEditList);